module.exports = __webpack_public_path__ + "static/media/banner.b3c2e8a7.png";